import { BaseService } from "./base.service";
import { Http } from "./http.init";
import { assert } from "@/core";
export class AboutsService extends BaseService {
  constructor() {
    super("abouts");
  }

  async saveFile(payload = {}) {
    assert.object(payload, { required: true });
    const response = await new Http({
      auth: true,
      headers: { "Content-Type": "multipart/form-data" }
    }).post(`${this.entity}`, payload);
    return response.data;
  }
}
